import React, { useState, useEffect, useContext} from "react"
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

import {
  Box,
  Container,
} from '@mui/material';

import RecruiterListUsers from "../components/scans/RecruiterListUsers"

import { getCurrentUser } from "../utils/auth"

const ViewScanUsers = () => {
  const navigate = useNavigate();

  let accountType = getCurrentUser()?.type

  useEffect(() => {
    if (accountType !== "theScanRecruiter") {
      navigate('/')
    }
  }, [accountType])

  return (
    <>
      <Helmet>
        <title>Candidats | TheScan</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'white',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        {accountType === "theScanRecruiter" &&
          <RecruiterListUsers/>
        }
      </Box>
    </>
  )
};

export default ViewScanUsers;
